//TODO: flesh out generic error types to be used across all models
import type { StorageAdapterType } from "../../storage/adapter";

export class SyncError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SyncError";
    this.stack = new Error(undefined).stack;
  }
}

export class CreationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CreationError";
    this.stack = new Error(undefined).stack;
  }
}

export class KeystoneError extends Error {
  constructor(message: string, cause?: Error | string, logNow = false) {
    super(message);
    this.name = "KeystoneError";
    this.stack = new Error(undefined).stack;
    this.cause ??= cause;
    if (logNow) {
      console.error(this);
    }
  }
}

export class RefError extends Error {
  constructor(message: string, cause?: Error | string, logNow = false) {
    super(message);
    this.name = "RefError";
    this.stack = new Error(undefined).stack;
    this.cause ??= cause;
    if (logNow) {
      console.error(this);
    }
  }
}

export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ApiError";
    this.stack = new Error(undefined).stack;
  }
}

export class ImmutableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ImmutableError";
    this.stack = new Error(undefined).stack;
  }
}

export type CoreError =
  | SyncError
  | CreationError
  | KeystoneError
  | ApiError
  | ImmutableError
  | RefError;

export class UninitializedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UninitializedError";
  }
}

export type StorageErrorKind = "env" | "space" | "perms" | "init";
export class StorageError extends Error {
  type: StorageAdapterType;
  kind: StorageErrorKind;

  constructor(
    type: StorageAdapterType,
    kind: StorageErrorKind,
    message?: string,
  ) {
    super(message, { cause: kind });
    this.name = "StorageError";
    this.type = type;
    this.kind = kind;
  }
}
